import { authHeaders } from '@/utils/authToken';
import type { AvailabilitySlot, AvailabilityTemplate } from '@/types';

export const availabilityService = {
  async list(from?: string, to?: string): Promise<AvailabilitySlot[]> {
    const params = new URLSearchParams();
    if (from) params.set('from', from);
    if (to) params.set('to', to);
    const res = await fetch(`/api/availability?${params}`, { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async create(slots: Partial<AvailabilitySlot> | Partial<AvailabilitySlot>[]): Promise<AvailabilitySlot[]> {
    const res = await fetch('/api/availability', {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify(slots),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async update(id: string, updates: Partial<AvailabilitySlot>): Promise<AvailabilitySlot> {
    const res = await fetch('/api/availability', {
      method: 'PUT',
      headers: await authHeaders(),
      body: JSON.stringify({ id, ...updates }),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async remove(id: string): Promise<void> {
    const res = await fetch(`/api/availability?id=${id}`, {
      method: 'DELETE',
      headers: await authHeaders(),
    });
    if (!res.ok) {
      const json = await res.json();
      throw new Error(json.error);
    }
  },

  async getTemplates(): Promise<AvailabilityTemplate[]> {
    const res = await fetch('/api/availability/template', { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async saveTemplates(templates: Partial<AvailabilityTemplate>[]): Promise<AvailabilityTemplate[]> {
    const res = await fetch('/api/availability/template', {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify(templates),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async applyTemplate(fromDate: string, toDate: string): Promise<AvailabilitySlot[]> {
    const res = await fetch('/api/availability/apply-template', {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify({ from_date: fromDate, to_date: toDate }),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },
};
